module.exports = __webpack_public_path__ + "kp.2935830adccf9654603d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/kp.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/kp.svg
// module chunks = styles